export function getPathBasename(path: String) {
	if (path == null) return ''
	return path
		.split(/[\\/]/)
		.pop()
		.replace(/\.[^/.]+$/, '')
}
